import urls from "../../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../../utils/service";

export async function getOfficeDetails(userId: String) {
    try {
      const callParams = await getCallParams("GET");
      const response = await makeCall(
        urls.GETEMPLOYEEOFFICEDETAILBYID + userId,
        callParams
      );
      return response;
    } catch (error) {
      throw error;
    }
  }


  export async function getBankDetails(userId: String) {
    try {
      const callParams = await getCallParams("GET");
      const response = await makeCall(
        urls.GETEMPLOYEEBANKDETAILBYID + userId,
        callParams
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  
  export async function getLeaveDetails(userId: String) {
    try {
      const callParams = await getCallParams("GET");
      const response = await makeCall(
        urls.GETEMPLOYEELEAVEDETAILBYID + userId,
        callParams
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  export async function getSalaryDetails(userId: String) {
    try {
      const callParams = await getCallParams("GET");
      const response = await makeCall(
        urls.GETEMPLOYEESALARYDETAILBYID + userId,
        callParams
      );
      return response;
    } catch (error) {
      throw error;
    }
  }